module.exports = __webpack_public_path__ + "static/media/FounderJane.656ee6bc.png";